export const DATADOG_ELEMENT_ID = 'datadog-values';
export const APPLICATION_ID_PLACEHOLDER = 'DATADOG-APPLICATION-ID';
export const CLIENT_TOKEN_PLACEHOLDER = 'DATADOG-CLIENT-TOKEN';
export const SERVICE_NAME_PLACEHOLDER = 'DATADOG-SERVICE-NAME';
export const SAMPLE_RATE_PLACEHOLDER = 'DATADOG-SAMPLE-RATE';
export const SESSION_REPLAY_SAMPLE_RATE_PLACEHOLDER = 'DATADOG-SESSION-REPLAY-SAMPLE-RATE';
export const LOGIN_APP_VERSION_PLACEHOLDER = 'LOGIN-APP-VERSION';
